import { useEffect } from "react";
import { getUniqueId } from "@/utils/cache.utils";
import { APP_PAGES } from "@tajawal/web-core-sdk-v2/lib/constants";
import { PaxType } from "@tajawal/web-flights-sdk/lib/types/common.types";
import { FlightProductModel } from "@tajawal/web-flights-sdk/lib/types/flight-product.types";
import {
  DomesticItinerary,
  ItineraryModel,
} from "@tajawal/web-flights-sdk/lib/types/itinerary.types";
import FlightInfoStore from "@tajawal/web-flights-sdk/lib/stores/flight-info.store";

const useFetchFareRules = ({
  store,
  itinerary,
  userId,
  page = APP_PAGES.FLIGHTS_PAX,
  flightProduct,
  shouldFetch = true,
  pax,
}: {
  store: FlightInfoStore;
  itinerary: ItineraryModel | DomesticItinerary;
  userId: string;
  page: string;
  pax: string | PaxType[];
  flightProduct: FlightProductModel;
  shouldFetch?: boolean;
}) => {
  useEffect(() => {
    if (store.fareRules.isLoading || !itinerary) return;
    if (shouldFetch) {
      const { carriers, id: itineraryId } = itinerary || {};
      const { fareUuids, vendors } = flightProduct || {};

      try {
        store.fareRules.fetch({
          itineraryId,
          userId: userId || getUniqueId(),
          page,
          vendors,
          pax,
          fareUuids,
          airlines: carriers,
        });
      } catch (e) {
        console.error("FARE_RULES_FETCH_ERROR");
      }
    }
  }, [itinerary?.id]);
};

export default useFetchFareRules;
